import { ChangeDetectorRef, Component, Inject, Injector, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { getLocaleNumberSymbol, JsonPipe, NumberSymbol } from '@angular/common';
import { Router } from '@angular/router';

import { KatexOptions } from 'ng-katex';

import * as $ from 'jquery';
import {
    CalculationCompound,
    CalculationInput,
    CalculationInputScreeningData,
    CalculationModelNames,
    CalculationModelType,
    CalculationType,
    Degradation,
    DKJordPolygon,
    DKJordPolygonResult,
    GeusParameterDanishNames,
    GeusParameterFlags,
    GeusParameterFlagsDanishNames,
    GeusParameterNames,
    GroundType,
    LocationGeusData,
    LocationGeusDataItem,
    LocationGeusDataV2,
    MagasinType,
    ModelDefaultValues,
    QualityCriterionType
} from 'src/app/contracts';
import { AuthService, contaminantNameValidator } from 'src/app/shared';
import { CalculationService, CompoundService, GeusCalculationService, LocationService } from 'src/app/services';
import { Subject } from 'rxjs';
import { catchError, finalize, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { AppConfig } from 'src/app/app.config';
import { PolygonGeusParameter, PolygonGeusParameterDanishNames } from '../../../contracts/enums';

@Component({
    selector: 'app-select-parameters',
    templateUrl: './select-parameters.component.html',
    styleUrls: ['./select-parameters.component.css']
})
export class SelectParametersComponent extends BaseComponent implements OnInit, OnDestroy {
    public loading = true;
    public userEmail = '';
    public sendMailOnComputationFinished = false;
    public hideGetDataFromGeuscalculator = AppConfig.hideGetDataFromGeuscalculator;

    public calculationModelNames = CalculationModelNames;
    public contaminant: CalculationCompound;
    public contaminantName: string;
    public contaminantNameControl = new FormControl('');

    public compoundList: CalculationCompound[];
    public degradationCompoundList: CalculationCompound[] = [];

    public locationId: string;
    public locationName: string;
    public locationNumber: string;
    public calculationType: CalculationType;
    public calculationInput: CalculationInput;
    public screeningData: CalculationInputScreeningData;

    public modelDefaultValues: ModelDefaultValues;
    public defaultAbstractionRate: 10000;
    public progress = 0;

    public filteredCompoundList: CalculationCompound[];

    public startingGeuscalculation = false;

    private $aerobicDegradation = true;
    public set aerobicDegradation(aerobicDegradation: boolean) {
        this.$aerobicDegradation = aerobicDegradation;
        this.calculationInput.aerobicDegradation = aerobicDegradation;
        this.updateHorizontalDegradationDefaultValues();
    }
    public get aerobicDegradation(): boolean { return this.$aerobicDegradation; }

    public set calculateFractureAperture(calculateFractureAperture: boolean) {
        this.calculationInput.calculateFractureAperture = calculateFractureAperture;
        if (calculateFractureAperture) {
            this.refreshGroundwaterVelocity();
        }
    }
    public get calculateFractureAperture(): boolean { return this.calculationInput.calculateFractureAperture; }

    public set calculateGroundwaterVelocity(calculateGroundwaterVelocity: boolean) {
        this.calculationInput.calculateGroundwaterVelocity = calculateGroundwaterVelocity;
        if (calculateGroundwaterVelocity) {
            this.refreshGroundwaterVelocity();
        }
    }
    public get calculateGroundwaterVelocity(): boolean { return this.calculationInput.calculateGroundwaterVelocity; }

    private $selectedMagasintype: MagasinType = MagasinType.quaternarySand;
    public set selectedMagasinType(type: MagasinType) {
        this.$selectedMagasintype = type;
        this.selectedMagasinTypeChanged();
    }
    public get selectedMagasinType(): MagasinType { return this.$selectedMagasintype; }

    private $selectedGroundType: GroundType = GroundType.FedLer;
    public set selectedGroundType(type: GroundType) {
        this.$selectedGroundType = type;
        this.selectedGroundTypeChanged();
    }
    public get selectedGroundType(): GroundType { return this.$selectedGroundType; }

    // tslint:disable-next-line: variable-name
    public Two_b_equation = '2b=\\left( \\frac{K_b \\cdot 12 \\cdot 0,0013\\cdot2B}{1000\\cdot9,81} \\right)^\\frac{1}{3}';
    // tslint:disable-next-line: variable-name
    public K_b_equation = 'K_b=\\frac{1000\\cdot9,81\\cdot(2b)^3}{ 12 \\cdot 0,0013\\cdot2B}';
    // tslint:disable-next-line: variable-name
    public u_equation = 'u=\\frac{K\\cdot i}{n}\\cdot3600\\cdot24\\cdot365';
    public options: KatexOptions = {
        displayMode: false,
    };

    public horizontalHydraulicConductivityRecommendedValue = 1.0e-4;
    public horizontalHydraulicConductivityMinValue = 1.0e-6;
    public horizontalHydraulicConductivityMaxValue = 1.0e-4;
    public horizontalPorosityRecommendedValue = 0.3;
    public horizontalPorosityMinValue = 0.25;
    public horizontalPorosityMaxValue = 0.4;

    public verticalPorosityRecommendedValue = 0.4;
    public verticalPorosityMinValue = 0.3;
    public verticalPorosityMaxValue = 0.6;
    public verticalWaterContentRecommendedValue = 0.3;
    public verticalWaterContentMinValue = 0.2;
    public verticalWaterContentMaxValue = 0.4;

    // Helpers to get access to enums in the template html
    public calculationModelType = CalculationModelType;
    public degradation = Degradation;
    public magasinType = MagasinType;
    public groundType = GroundType;

    // UI helpers
    public showVerticalPorosityDropdown = false;
    public showVerticalWaterContentDropdown = false;
    public showHorizontalHydraulicConductivityDropdown = false;
    public showHorizontalPorosityDropdown = false;
    public canSelectSequentialDegradation = false;

    // Helps update pipe whenever needed
    public changeIndicator = 0;

    public tempParameters: any = {};

    public isStarting = false;
    public calculationErrorMessage: string | null = null;

    public locationGeusData: LocationGeusData;

    public selectedGeusDataItem: LocationGeusDataItem;
    public selectedItemIndex: number;

    protected destroyed$ = new Subject<void>();
    protected defaultSelectedIndex = -1;

    public locationGeusDataCalculated: DKJordPolygonResult;
    public errorGeusCalculation: string | null = null;
    public selectedPolygonIndex = -1;
    public selectedPolygon: DKJordPolygon | null = null;
    public geusCalculationStatusMessage: string | null = '';

    public hideStartGeusButton: boolean = true;

    constructor(
        @Inject(LOCALE_ID) locale,
        private readonly injector: Injector,
        private readonly router: Router,
        private readonly authService: AuthService,
        private readonly calculationService: CalculationService,
        private readonly compoundService: CompoundService,
        private readonly locationService: LocationService,
        private readonly geusCalculationService: GeusCalculationService) {
        super(locale);
        this.selectedItemIndex = this.defaultSelectedIndex;
    }

    public ngOnInit(): void {
        this.loading = true;
        this.userEmail = this.authService.getUserEmail();

        // Wait until the compound list has been loaded
        this.compoundService.getCompounds()
            .pipe(
                takeUntil(this.destroyed$),
                map((response: Array<CalculationCompound>) => response.sort(this.sortAlphabetically))
            )
            .subscribe((res : any) => {
                this.compoundList = res;
                this.filteredCompoundList = [...res];

                this.contaminantNameControl.setValidators(contaminantNameValidator(this.compoundList));
                this.contaminantNameControl.valueChanges
                    .pipe(takeUntil(this.destroyed$))
                    .subscribe(value => this.filterContaminants(value));

                const tempData = this.calculationService.getCalculationTempData();
                this.calculationInput = tempData.tempCalculationInput;

                this.locationId = tempData.tempLocationId;
                this.locationName = tempData.tempLocationName;
                this.locationNumber = tempData.tempLocationNumber;

                this.locationService.getGeusData(this.locationNumber)
                    .pipe(takeUntil(this.destroyed$))
                    .subscribe((response: LocationGeusData) => {
                        this.locationGeusData = response;
                    });

                this.calculationType = tempData.tempCalculationType;
                this.screeningData = tempData.tempScreeningData;

                if (!this.calculationInput.modelType) {
                    this.setModel(tempData.tempCalculationModel, true);
                } else {
                    this.modelDefaultValues = this.calculationService.getModelDefaultValues(this.calculationInput.modelType);
                }

                if (!this.calculationInput.degradation) {
                    this.calculationInput.degradation = Degradation.None;
                }

                this.defaultAbstractionRate = 10000;
                if (!this.calculationInput.abstractionRate) {
                    this.calculationInput.abstractionRate = this.defaultAbstractionRate;
                }
                this.$aerobicDegradation = tempData.tempCalculationInput.aerobicDegradation;

                if (this.calculationInput.contaminantCasNr) {
                    this.filteredCompoundList = this.compoundList
                        .filter(c => c.casNo === this.calculationInput.contaminantCasNr);
                    this.contaminant = this.filteredCompoundList[0];
                    this.contaminantName = this.contaminant ? this.contaminant.name : '';
                    this.contaminantNameControl.setValue(this.contaminantName, { emitEvent: false });
                    this.updateDegradationCompoundList();
                } else {
                    this.setContaminant(null);
                }

                if (this.screeningData) {
                    this.calculationInput.sourceInfiltration = this.roundNumber(this.screeningData.infiltration);
                    this.calculationInput.plumeInfiltration = this.roundNumber(this.screeningData.infiltration);
                    this.calculationInput.sourceToAquiferDist = this.roundNumber(this.screeningData.aquiferDepth);
                }

                if (!tempData.isCopyData) {
                    this.selectedGroundTypeChanged();
                    this.selectedMagasinTypeChanged();
                }
                this.loading = false;
            });

        this.hideStartGeusButton = this.authService.isExternalUser();
        if (this.authService.isOperator() || this.authService.isFullAccessUser()) {
            this.hideStartGeusButton = false;
        }
    }

    public filterContaminants(contaminantName: string): void {
        if (!contaminantName) {
            this.filteredCompoundList = this.compoundList;
        } else {
            this.filteredCompoundList = this.compoundList
                .filter(c =>
                    c.name.toLowerCase().indexOf(contaminantName.toLowerCase()) >= 0
                    || c.alternativeName.toLocaleLowerCase().indexOf(contaminantName.toLowerCase()) >= 0);

            const exactMatch = this.compoundList.filter(c =>
                c.name.toLowerCase() === contaminantName.toLowerCase()
                || c.alternativeName.toLocaleLowerCase() === contaminantName.toLowerCase());
            if (exactMatch.length === 1) {
                this.setContaminant(exactMatch[0]);
            }
        }
    }

    public finishGeusDataSelection(): void {
        this.calculationInput.sourceInfiltration = this.roundNumber(this.selectedGeusDataItem.infiltration);
        this.calculationInput.plumeInfiltration = this.roundNumber(this.selectedGeusDataItem.infiltration);

        if (this.calculationInput.modelType !== CalculationModelType.ModelV && this.calculationInput.modelType !== CalculationModelType.ModelIV) {
            this.calculationInput.sourceToAquiferDist = this.roundNumber(this.selectedGeusDataItem.aquiferDepth);
        }

        if (this.calculationInput.calculateGroundwaterVelocity) {
            this.calculationInput.hydraulicGradient = this.selectedGeusDataItem.headGradient;
            this.refreshGroundwaterVelocity();
        }

        let hasPolygon = false;
        let polygonGeusParameter = 'Flade:\n';
        for (const geusParam in this.selectedGeusDataItem) {
            if (PolygonGeusParameterDanishNames.has(geusParam as PolygonGeusParameter)) {
                hasPolygon = true;
                polygonGeusParameter += `\t${PolygonGeusParameterDanishNames.get(geusParam as PolygonGeusParameter)}: ${this.formatText(this.selectedGeusDataItem[geusParam])}\n`;
            }
        }

        let pollutionSourceComment = 'Data indsat for Geusberegneren:\n';

        if (hasPolygon) {
            pollutionSourceComment = polygonGeusParameter + '\n' + pollutionSourceComment;
        }

        for (const geusParam in this.selectedGeusDataItem) {
            if (GeusParameterDanishNames.has(geusParam as GeusParameterNames)) {
                pollutionSourceComment += `\t${GeusParameterDanishNames.get(geusParam as GeusParameterNames)}: ${this.formatText(this.selectedGeusDataItem[geusParam])}\n`;
            }
        }

        let hasFlag = false;
        let flagComment = '\nFlag:\n';
        for (const geusParam in this.selectedGeusDataItem) {
            if (GeusParameterFlagsDanishNames.has(geusParam as GeusParameterFlags)) {
                hasFlag = true;
                flagComment += `\t${GeusParameterFlagsDanishNames.get(geusParam as GeusParameterFlags)}: ${this.formatText(this.selectedGeusDataItem[geusParam])}\n`;
            }
        }
        if (hasFlag) {
            pollutionSourceComment += flagComment;
        }
        this.calculationInput.pollutionSourceComment = pollutionSourceComment;
    }

    public selectGeusDataItem(selected: LocationGeusDataItem, selectedIndex: number): void {
        if (!this.selectedGeusDataItem) {
            this.selectedGeusDataItem = selected;
            this.selectedItemIndex = selectedIndex;
            return;
        }

        if (this.selectedItemIndex === selectedIndex) {
            this.selectedGeusDataItem = null;
            this.selectedItemIndex = this.defaultSelectedIndex;
            return;
        }

        this.selectedGeusDataItem = selected;
        this.selectedItemIndex = selectedIndex;
    }

    public setModel(model: CalculationModelType, initialModel: boolean = false): void {
        this.calculationInput.modelType = model;
        this.modelDefaultValues = this.calculationService.getModelDefaultValues(model);
        this.calculationInput.verticalLongitudinalDispersivity = this.modelDefaultValues.verticalLongitudinalDispersivity;
        this.calculationInput.verticalTransversalDispersivity = this.modelDefaultValues.verticalTransversalDispersivity;
        this.calculationInput.fractureSpacing = this.modelDefaultValues.fractureSpacing;
        this.calculationInput.horizontalLongitudinalDispersivity = this.modelDefaultValues.horizontalLongitudinalDispersivity;
        this.calculationInput.horizontalTransversalDispersivity = this.modelDefaultValues.horizontalTransversalDispersivity;
        this.calculationInput.horizontalVerticalDispersivity = this.modelDefaultValues.horizontalVerticalDispersivity;
        this.setBulkHydraulicConductivity(this.modelDefaultValues.bulkHydraulicConductivity);

        if (!initialModel) {
            if (this.calculationInput.sourceLength === 0) {
                this.calculationInput.sourceLength = undefined;
            }
            if (this.calculationInput.sourceWidth === 0) {
                this.calculationInput.sourceWidth = undefined;
            }
            if (this.calculationInput.sourceRadius === 0) {
                this.calculationInput.sourceRadius = undefined;
            }
            if (this.calculationInput.verticalPorosity === 0) {
                this.calculationInput.verticalPorosity = undefined;
            }
            if (this.calculationInput.horizontalPorosity === 0) {
                this.calculationInput.horizontalPorosity = undefined;
            }
            if (this.calculationInput.capillaryFringe === 0) {
                this.calculationInput.capillaryFringe = undefined;
            }
            if (this.calculationInput.concentrationZeroRadius === 0) {
                this.calculationInput.concentrationZeroRadius = undefined;
            }
            if (this.calculationInput.sourceInfiltration === 0) {
                this.calculationInput.sourceInfiltration = undefined;
            }
            if (this.calculationInput.sourceToAquiferDist === 0) {
                this.calculationInput.sourceToAquiferDist = undefined;
            }
        }
    }

    public setDegradation(degradation: Degradation): void {
        this.calculationInput.degradation = degradation;
        this.updateDegradationCompoundList();
        this.setDegradationValues();
    }

    public setContaminant(contaminant: CalculationCompound): void {
        this.contaminant = contaminant;
        let isChange = contaminant && contaminant.casNo !== this.calculationInput.contaminantCasNr;

        this.calculationInput.contaminantName = contaminant ? contaminant.name : null;
        this.calculationInput.contaminantCasNr =
            contaminant && contaminant.casNo?.trim() !== ''
                ? contaminant.casNo
                : contaminant?.scCodeId?.toString() ?? null;
        
        this.calculationInput.freeDiffusionCoefficientInWater = contaminant ? contaminant.diffusionCoefficient.water : null;
        this.updateDegradationCompoundList();
        if (isChange) 
            this.setDegradationValues();
    }

    public updateDegradationCompoundList(): void {
        const degradationCasNrList = this.contaminant
            ? this.compoundService.getDegradationCompounds(
                this.calculationInput.contaminantCasNr, this.calculationInput.degradation) : [];

        degradationCasNrList.forEach((casNo: any, index: number) => {
            this.degradationCompoundList[index] = this.compoundList.find(c => c.casNo === casNo || c.scCodeId?.toString() === casNo);
            if (casNo === this.calculationInput.contaminantCasNr) {
                this.calculationInput.contaminantIndexInChain = index;
            }
        });
        this.degradationCompoundList.length = degradationCasNrList.length;

        // If sequential degradation was selected, but the user selects a compound
        // not in any degradation chains, change to simple degradation
        if (this.calculationInput.degradation === Degradation.Sequential
            && this.degradationCompoundList.length === 1) {
            this.calculationInput.degradation = Degradation.Simple;
        }

        // Check if the current compound is in a chain
        this.canSelectSequentialDegradation = this.compoundService.getDegradationCompounds(
            this.calculationInput.contaminantCasNr, Degradation.Sequential).length > 1;
    }

    public setDegradationValues(): void {
        // Reset the value
        this.calculationInput.degradationChainCompoundNames = [null, null, null, null];
        this.calculationInput.degradationChainQualityCriteria = [null, null, null, null];
        this.calculationInput.degradationChainQualityCriteriaType = [null, null, null, null];
        this.calculationInput.verticalFirstOrderDegradationRate = [null, null, null, null];
        this.calculationInput.henrysConstant = [null, null, null, null];
        this.calculationInput.freeDiffusionCoefficientInAir = [null, null, null, null];

        this.calculationInput.stoichiometricRatio = [null, null, null, null];
        this.calculationInput.horizontalFirstOrderDegradationRate = [null, null, null, null];

        this.calculationInput.compoundCount = this.degradationCompoundList.length;
        // tslint:disable-next-line: forin
        for (const i in this.degradationCompoundList) {
            const compound = this.degradationCompoundList[i];
            this.calculationInput.degradationChainCompoundNames[i] = compound.name;

            this.calculationInput.degradationChainQualityCriteria[i] = compound.groundWaterQualityCriterion
                ?? compound.drinkingWaterQualityCriterion
                ?? compound.fictitiousCriterion;

            if (compound.groundWaterQualityCriterion) {
                this.calculationInput.degradationChainQualityCriteriaType[i] = QualityCriterionType.GVK;
            } else if (compound.drinkingWaterQualityCriterion) {
                this.calculationInput.degradationChainQualityCriteriaType[i] = QualityCriterionType.DVK;
            } else if (compound.fictitiousCriterion) {
                this.calculationInput.degradationChainQualityCriteriaType[i] = QualityCriterionType.Fictitious;
            } else {
                this.calculationInput.degradationChainQualityCriteriaType[i] = null;
            }

            this.calculationInput.verticalFirstOrderDegradationRate[i] = this.getVerticalFirstOrderDegrationRate(compound);
            this.calculationInput.henrysConstant[i] = compound.henrysConstant;
            this.calculationInput.freeDiffusionCoefficientInAir[i] = compound.diffusionCoefficient.air;
        }

        const stoichiometricRatioList = this.contaminant
            ? this.compoundService.getStoichiometricRatioList(
                this.contaminant, this.calculationInput.degradation) : [];
        // tslint:disable-next-line: forin
        for (const i in stoichiometricRatioList) {
            this.calculationInput.stoichiometricRatio[i] = stoichiometricRatioList[i];
        }
        this.updateHorizontalDegradationDefaultValues();

        if (this.calculationInput.degradation === Degradation.None) {
            this.calculationInput.verticalFirstOrderDegradationRate[0] = 0.0;
            this.calculationInput.horizontalFirstOrderDegradationRate[0] = 0.0;
        }
    }

    public updateHorizontalDegradationDefaultValues(): void {
        // tslint:disable-next-line: forin
        for (const i in this.degradationCompoundList) {
            const compound = this.degradationCompoundList[i];
            if (this.aerobicDegradation) {
                this.calculationInput.horizontalFirstOrderDegradationRate[i] = compound.aerobicDegradationRate.value;
            } else {
                this.calculationInput.horizontalFirstOrderDegradationRate[i] = compound.anaerobicDegradationRate.value;
            }
        }
    }

    public getVerticalFirstOrderDegrationRate(compound: CalculationCompound): number | null {
        if (!compound.standat) {
            return null;
        }

        if (this.calculationInput.degradation !== Degradation.Simple) {
            return compound.verticalFirstOrderDegradationRate;
        }

        if (this.calculationInput.modelType !== CalculationModelType.ModelIII
            && this.calculationInput.modelType !== CalculationModelType.ModelIV) {
                return compound.verticalFirstOrderDegradationRate;
        }

        const compoundStandat = this.compoundService.getVerticalDegradation(compound.standat);
        return compoundStandat ?? compound.verticalFirstOrderDegradationRate;
    }

    public selectedGroundTypeChanged(): void {
        switch (this.$selectedGroundType) {
            case GroundType.FedLer:
                this.verticalPorosityRecommendedValue = 0.4;
                this.verticalPorosityMinValue = 0.3;
                this.verticalPorosityMaxValue = 0.6;
                this.verticalWaterContentRecommendedValue = 0.3;
                this.verticalWaterContentMinValue = 0.2;
                this.verticalWaterContentMaxValue = 0.4;
                break;
            case GroundType.MoræneLer:
                this.verticalPorosityRecommendedValue = 0.25;
                this.verticalPorosityMinValue = 0.1;
                this.verticalPorosityMaxValue = 0.3;
                this.verticalWaterContentRecommendedValue = 0.2;
                this.verticalWaterContentMinValue = 0.125;
                this.verticalWaterContentMaxValue = 0.25;
                break;
            case GroundType.Sand:
                this.verticalPorosityRecommendedValue = 0.3;
                this.verticalPorosityMinValue = 0.25;
                this.verticalPorosityMaxValue = 0.4;
                this.verticalWaterContentRecommendedValue = 0.1;
                this.verticalWaterContentMinValue = 0.03;
                this.verticalWaterContentMaxValue = 0.23;
                break;
            case GroundType.Silt:
                this.verticalPorosityRecommendedValue = 0.4;
                this.verticalPorosityMinValue = 0.35;
                this.verticalPorosityMaxValue = 0.5;
                this.verticalWaterContentRecommendedValue = 0.3;
                this.verticalWaterContentMinValue = 0.2;
                this.verticalWaterContentMaxValue = 0.4;
                break;
            case GroundType.SandOgGrus:
                this.verticalPorosityRecommendedValue = 0.25;
                this.verticalPorosityMinValue = 0.15;
                this.verticalPorosityMaxValue = 0.35;
                // this.verticalWaterContentRecommendedValue = 0.08;
                this.verticalWaterContentRecommendedValue = 0.2;
                this.verticalWaterContentMinValue = 0.03;
                this.verticalWaterContentMaxValue = 0.19;
                break;
        }

        // if (this.calculationInput.waterContent === undefined) {
        //    this.calculationInput.waterContent = this.verticalWaterContentRecommendedValue;
        // }
        this.calculationInput.waterContent = this.verticalWaterContentRecommendedValue;

        // if (this.calculationInput.verticalPorosity === undefined) {
        //    this.calculationInput.verticalPorosity = this.verticalPorosityRecommendedValue;
        // }
        this.calculationInput.verticalPorosity = this.verticalPorosityRecommendedValue;
    }

    public selectedMagasinTypeChanged(): void {
        switch (this.$selectedMagasintype) {
            case MagasinType.quaternarySand:
                this.horizontalHydraulicConductivityRecommendedValue = 1.0e-4;
                this.horizontalHydraulicConductivityMinValue = 1.0e-5;
                this.horizontalHydraulicConductivityMaxValue = 1.0e-3;
                this.horizontalPorosityRecommendedValue = 0.3;
                this.horizontalPorosityMinValue = 0.25;
                this.horizontalPorosityMaxValue = 0.4;
                break;
            case MagasinType.preQuaternarySand:
                this.horizontalHydraulicConductivityRecommendedValue = 1.0e-4;
                this.horizontalHydraulicConductivityMinValue = 1.0e-6;
                this.horizontalHydraulicConductivityMaxValue = 1.0e-4;
                this.horizontalPorosityRecommendedValue = 0.3;
                this.horizontalPorosityMinValue = 0.25;
                this.horizontalPorosityMaxValue = 0.4;
                break;
            case MagasinType.crackedLime:
                this.horizontalHydraulicConductivityRecommendedValue = 1.0e-4;
                this.horizontalHydraulicConductivityMinValue = 1.0e-5;
                this.horizontalHydraulicConductivityMaxValue = 1.0e-3;
                this.horizontalPorosityRecommendedValue = 0.05;
                this.horizontalPorosityMinValue = 0.001;
                this.horizontalPorosityMaxValue = 0.15;
                break;
        }

        if (this.screeningData && this.screeningData.hydraulicConductivity) {
            this.calculationInput.hydraulicConductivity = this.screeningData.hydraulicConductivity;
        }
        else {
            this.calculationInput.hydraulicConductivity = this.horizontalHydraulicConductivityRecommendedValue;
        }

        // if (this.calculationInput.horizontalPorosity === undefined) {
        //    this.calculationInput.horizontalPorosity = this.horizontalPorosityRecommendedValue;
        // }
        this.calculationInput.horizontalPorosity = this.horizontalPorosityRecommendedValue;

        this.refreshGroundwaterVelocity();
    }

    public setFractureSpacing(value: number): void {
        this.calculationInput.fractureSpacing = value;
        if (this.calculationInput.calculateFractureAperture) {
            this.setBulkHydraulicConductivity(this.calculationInput.bulkHydraulicConductivity);
        }
        else {
            this.setFractureAperture(this.calculationInput.fractureAperture);
        }
    }

    public setFractureAperture(value: number): void {
        this.calculationInput.fractureAperture = value;
        const Twob = value;
        const TwoB = this.calculationInput.fractureSpacing;
        if (Twob && TwoB) {
            this.calculationInput.bulkHydraulicConductivity = (1000.0 * 9.81 * Math.pow(Twob, 3)) / (12.0 * 0.0013 * TwoB);
        } else {
            this.calculationInput.bulkHydraulicConductivity = 0;
        }
    }

    public setBulkHydraulicConductivity(value: number): void {
        this.calculationInput.bulkHydraulicConductivity = value;
        // tslint:disable-next-line: variable-name
        const K_b = value;
        const TwoB = this.calculationInput.fractureSpacing;
        if (K_b && TwoB) {
            this.calculationInput.fractureAperture = Math.pow((K_b * 12 * 0.0013 * TwoB) / (1000.0 * 9.81), 1.0 / 3.0);
        } else {
            this.calculationInput.fractureAperture = 0;
        }
    }

    public refreshGroundwaterVelocity(): void {
        if (!this.calculationInput.calculateGroundwaterVelocity) {
            return;
        }

        const hk = this.calculationInput.hydraulicConductivity;
        const grad = this.calculationInput.hydraulicGradient;
        const n = this.calculationInput.horizontalPorosity;

        if (!hk || !grad || !n) {
            this.calculationInput.groundwaterVelocity = null;
        }
        else {
            this.calculationInput.groundwaterVelocity = ((hk * grad) / n) * 3600 * 24 * 365;
        }
    }

    public verifyWaterContent(): void {
        if (this.calculationInput.modelType === CalculationModelType.ModelIII
            || this.calculationInput.modelType === CalculationModelType.ModelIV) {
            if (this.calculationInput.waterContent > this.calculationInput.verticalPorosity) {
                this.calculationInput.waterContent = this.calculationInput.verticalPorosity;
            }
            if (isNaN(this.calculationInput.waterContent)){
                // tslint:disable-next-line: no-string-literal
                this.tempParameters['waterContent'] = this.calculationInput.verticalPorosity;
                this.calculationInput.waterContent = this.calculationInput.verticalPorosity;
            }
        }
    }

    public localizedParseFloat(value: any, valueName: string | null = null): number {
        const localeId = this.injector.get(LOCALE_ID);
        const groupSep = getLocaleNumberSymbol(localeId, NumberSymbol.Group);
        const decimalSep = getLocaleNumberSymbol(localeId, NumberSymbol.Decimal);
        const valueNoGroupSep = this.stringReplaceAll(value, groupSep, '');
        const valueWithEnglishDecimal = this.stringReplaceAll(valueNoGroupSep, decimalSep, '.');
        const result = Number(valueWithEnglishDecimal);
        this.changeIndicator++;

        const expRegex1 = /-?(?:0|[1-9]\d*)(?:\,\d*)?(?:[eE])?/;
        const expRegex2 = /-?(?:0|[1-9]\d*)(?:\,\d*)?(?:[eE][+\-])?/;
        const expRegexFull = /-?(?:0|[1-9]\d*)(?:\,\d*)?(?:[eE][+\-]?\d+)?/;

        if (valueName != null) {
            if (!isNaN(result)) {
                this.tempParameters[valueName] = value;
            }
            else if (expRegex1.test(value)) {
                this.tempParameters[valueName] = value;
            }
            else if (expRegex2.test(value)) {
                this.tempParameters[valueName] = value;
            }
            else if (expRegexFull.test(value)) {
                this.tempParameters[valueName] = value;
            }
            else {
                this.tempParameters[valueName] = '';
            }

        }

        return result;
    }

    public stringReplaceAll(s: string, find: string, replace: string): string {
        if (find === replace) {
            return s;
        }
        let temp = s;
        let index = temp.indexOf(find);
        while (index !== -1) {
            temp = temp.replace(find, replace);
            index = temp.indexOf(find);
        }
        return temp;
    }

    public startCalculation(): void {
        const modal = $('#toggleConfirmModalButton');
        modal.click();
    }

    public confirmStartCalculation(): void {
        const dismissModel = $('#dismissModalButton');
        dismissModel.click();

        this.calculationInput.userEmail = this.userEmail;
        this.calculationInput.sendMailOnComputationFinished = this.sendMailOnComputationFinished;

        this.isStarting = true;
        this.calculationErrorMessage = '';
        const calculationInput = this.getCalculationInput();

        this.calculationService.startCalculation(this.locationId, this.calculationType, calculationInput)
            .subscribe(
                (res: any) => {
                    this.isStarting = false;
                    this.router.navigate(['riskassessment/calculation-result/' + res]);
                },
                (err: any) => {
                    this.isStarting = false;
                    const showModal = $('#toggleConfirmModalButton');
                    showModal.click();
                    this.calculationErrorMessage = err.error;
                }
            );
    }

    public getCalculationInput(): CalculationInput {
        const input = { ...this.calculationInput };
        input.sourceConcentration = input.sourceConcentration.filter((p: any) => p !== null && p !== undefined);
        input.degradationChainCompoundNames = input.degradationChainCompoundNames.filter((p: any) => p !== null && p !== undefined);
        input.degradationChainQualityCriteria = input.degradationChainQualityCriteria.filter((p: any) => p !== null && p !== undefined);
        input.degradationChainQualityCriteriaType = input.degradationChainQualityCriteriaType.filter((p: any) => p !== null && p !== undefined);
        input.stoichiometricRatio = input.stoichiometricRatio.filter((p: any) => p !== null && p !== undefined);
        input.henrysConstant = input.henrysConstant.filter((p: any) => p !== null && p !== undefined);
        input.freeDiffusionCoefficientInAir = input.freeDiffusionCoefficientInAir.filter((p: any) => p !== null && p !== undefined);
        input.verticalFirstOrderDegradationRate = input.verticalFirstOrderDegradationRate.filter((p: any) => p !== null && p !== undefined);
        input.horizontalFirstOrderDegradationRate = input.horizontalFirstOrderDegradationRate.filter((p: any) => p !== null && p !== undefined);
        return input;
    }

    public changeVerticalPorosity(): void {
        this.calculationInput.waterContent = this.calculationInput.verticalPorosity;
    }

    public roundNumber(value: number): number {
        return Math.round(value * 100) / 100;
    }

    /**
     * Start GEUS calculation process
     */
    public startGeuscalculation(): void {
        if (!this.locationNumber) {
            return;
        }
        this.progress = 0;
        this.startingGeuscalculation = true;
        document.body.classList.add('no-scroll');
        this.selectedPolygonIndex = -1;
        this.selectedGeusDataItem = null;
        this.errorGeusCalculation = '';

        let interval = setInterval(() => {
            if (this.progress < 30) {
                this.progress += 5;
            }
        }, 300);

        this.geusCalculationStatusMessage = 'Jupiter XL er den i live?';

        // request to check Jupiter XL database status
        this.geusCalculationService.checkJupiterXlDatabaseStatus()
        .pipe(
            takeUntil(this.destroyed$),
            // Step 1 → Step 2
            switchMap((checkingAvailable: any) => {

                this.progress = 30;
                clearInterval(interval);

                interval = setInterval(() => {
                    if (this.progress < 60) {
                        this.progress += 10;
                    }
                }, 300);

                const { isAvailable } = checkingAvailable;

                if (!isAvailable) {
                    this.geusCalculationStatusMessage = null;
                    throw new Error('Geus beregningen kan ikke gennemgøres da JupierXl databasen ikke er tilgængelig. Prøv evt. igen senere');
                }
                // request DK Jord polygons by location number
                this.geusCalculationStatusMessage = 'Henter Dkjord data';
                return this.geusCalculationService.fetchDkJordPolygons(this.locationNumber)
                .pipe(
                    catchError(err => {
                        this.geusCalculationStatusMessage = null;
                        throw new Error('Der er ikke fundet data i Dkjord for lokaliteten ' + this.locationNumber);
                    })
                );
            }),
            // Step 2 → Step 3
            tap((result: DKJordPolygonResult) => {
                this.progress = 60;
                // showing dialog to select one polygon
                const { polygonData: data } = result;

                if (data.length === 1) {
                    // Call Step 3 immediately
                    this.startGeusCalculationForSelectedPolygon(data[0], false);
                } else if (data.length > 1) {
                    this.progress = 100;

                    // Step 3 will be called when user selects one polygon
                    this.locationGeusDataCalculated = {... result};
                    setTimeout(() => {
                        this.startingGeuscalculation = false;
                        $('#toggleGeusDataCalculateModalButton').click();
                    }, 300);
                }
            }),
            finalize(() => {
                setTimeout(() => {
                    document.body.classList.remove('no-scroll');
                }, 300);
                clearInterval(interval);
            }),
        )
        .subscribe({
            next: () => {},
            error: (err: any) => {
                if (err) {
                    this.progress = 100;
                    this.startingGeuscalculation = false;
                    this.showingErrorGeusCalculation(err);
                }
            }
        });
    }

    /**
     * Start GEUS calculation for the selected polygon
     * @param polygonSelected selected polygon to request GEUS calculation
     * @param isNewStep whether this is a new step in the process
     */
    public startGeusCalculationForSelectedPolygon(polygonSelected: DKJordPolygon, isNewStep: boolean = true): void {
        const { shape, pollutionStatus } = polygonSelected;
        this.geusCalculationStatusMessage = 'Laver beregning';

        // isNewStep is decide to reset progress bar and show dialog or not
        if (isNewStep) {
            this.progress = 0;
            this.startingGeuscalculation = true;
            document.body.classList.add('no-scroll');
        }

        const interval = setInterval(() => {
            if (this.progress < 90) {
                this.progress += 5;
            }
        }, 200);

        // request GEUS calculation by polygon
        this.geusCalculationService.geusCalculateByPolygon(this.locationNumber, pollutionStatus, shape)
            .pipe(
                takeUntil(this.destroyed$),
                finalize(() => {
                    // execute progress bar and dialog
                    this.progress = 100;
                    setTimeout(() => {
                        this.startingGeuscalculation = false;
                        document.body.classList.remove('no-scroll');
                    }, 300);
                    clearInterval(interval);
                })
            )
            .subscribe({
                next: (result: LocationGeusDataV2) => {
                    const { data } = result;
                    this.selectedGeusDataItem = { ...data };
                    this.finishGeusDataSelection();
                },
                error: (err: any) => {
                    this.showingErrorGeusCalculation(err);
                }
            });
    }

    /**
     * Show error message for GEUS calculation
     * @param err error object from the GEUS calculation
     */
    public showingErrorGeusCalculation(err: any): void {
        this.geusCalculationStatusMessage = null;
        const errorStr: string = err.message || err.error;
        const errorIndex = errorStr.indexOf('Error:');
        this.errorGeusCalculation = errorIndex >= 0
            ? errorStr.substring(errorIndex).replace('Error:', 'Fejl:')
            : errorStr;
    }

    public selectPolygonGeusCalculate(selected: DKJordPolygon, selectedIndex: number): void {
        if (!this.selectedPolygon) {
            this.selectedPolygon = selected;
            this.selectedPolygonIndex = selectedIndex;
            return;
        }

        if (this.selectedPolygonIndex === selectedIndex) {
            this.selectedPolygon = null;
            this.selectedPolygonIndex = this.defaultSelectedIndex;
            return;
        }

        this.selectedPolygon = selected;
        this.selectedPolygonIndex = selectedIndex;
    }

    public formatText(value: any): string {
        if (value === null || value === undefined) {
            return '';
        }

        if (typeof value === 'number' && !isNaN(value)) {
            value = this.showFormatNumber(value);
        }
        else {
            value = this.capitalizeFirst(value);
        }
        return value;
    }

    public showFormatNumber(value: number, locale: string = 'da-DK'): string {

        if (Math.abs(value) < 1e-2) {
            return new Intl.NumberFormat(locale, { maximumFractionDigits: 20, useGrouping: false }).format(value);
        }

        return new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(value);
    }

    public capitalizeFirst(value: any): string {
        if (value === null || value === undefined) {
            return '';
        }
        const str = value.toString();
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    public ngOnDestroy(): void {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    protected sortAlphabetically(compoundA: CalculationCompound, compoundB: CalculationCompound): number {
        if (compoundA.name < compoundB.name) {
            return -1;
        }
        if (compoundA.name > compoundB.name) {
            return 1;
        }
        return 0;
    }
}
